import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { pageMeta } from "@/lib/seo/meta";
import { TOOL_CACHE_HEADERS } from "@/lib/seo/headers";

const PdfToPptView = lazy(() => import("@/features/pdf-to-ppt/view"));

export const Route = createFileRoute("/pdf-to-ppt")({
  head: () =>
    pageMeta({
      title: "PDF to PowerPoint",
      description: "Turn any PDF into an editable PowerPoint deck. Coming soon.",
      path: "/pdf-to-ppt",
      keywords: "pdf to ppt, pdf to pptx, pdf to powerpoint, online, free",
    }),
  headers: () => TOOL_CACHE_HEADERS,
  component: () => (
    <Suspense fallback={null}>
      <PdfToPptView />
    </Suspense>
  ),
});
